import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY } from "../data/content";

export const FloatingCall = () => (
  <motion.a
    href={PHONE_TEL}
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 2.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    className="group fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-full bg-sage pl-3 pr-5 py-3 text-cream shadow-[0_20px_40px_-15px_rgba(62,92,75,0.7)] md:bottom-8 md:right-8"
    aria-label={`Chiama ${PHONE_DISPLAY}`}
    data-testid="floating-call-btn"
  >
    <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-gold">
      <span className="absolute inset-0 rounded-full bg-gold animate-pulseRing" />
      <Phone className="relative h-4 w-4 text-white" />
    </span>
    <span className="flex flex-col leading-tight">
      <span className="text-[10px] uppercase tracking-[0.2em] text-cream/60">Chiama ora</span>
      <span className="text-sm font-semibold">{PHONE_DISPLAY}</span>
    </span>
  </motion.a>
);
